export default __webpack_public_path__ + "static/3-129c4396840ff345b4de556d392e0611.jpg";